import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let GeneralInfoComponent = {
    selector: "vcGeneralInfo",
    templateUrl: "/angular/components/general/general-info.component.html",
    bindings: {
        title: "=?",
        bodyText: "=?",
        buttonText: "=?",
    },
    controller: class GeneralInfoController {
        // * bindings for typescript compiler *
        public title?: string;
        public bodyText?: string;
        public buttonText?: string;
        // ************************************

        public cancelButtonText: string;
        public confirmButtonText: string;

        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.cancelButtonText =
                this.buttonText && this.buttonText["cancel"]
                    ? this.buttonText["cancel"]
                    : "Cancel";
            this.confirmButtonText =
                this.buttonText && this.buttonText["confirm"]
                    ? this.buttonText["confirm"]
                    : "Confirm";
        }

        confirm(): void {
            this.dialog.hide();
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("general")
    .component(GeneralInfoComponent.selector, GeneralInfoComponent);
